<template>
  <div
    class="flex font-sans select-none"
    style="width: 1200px; height: 628px; padding-left: 72px; background: radial-gradient(125% 145% at 82% -10%, #2f1a47 0%, #16151a 52%); position: relative;"
  >
    <!-- Panneau gauche : identité -->
    <div class="flex flex-col items-center justify-center text-center" style="width: 38%; padding: 52px 36px; gap: 26px;">
      <img
        v-if="photoDataUrl"
        :src="photoDataUrl"
        alt=""
        style="width: 256px; height: 256px; border-radius: 9999px; object-fit: cover; border: 6px solid #9E64FF; box-shadow: 0 0 0 14px rgba(158,100,255,.16);"
      />
      <div
        v-else
        class="flex items-center justify-center font-extrabold text-white"
        style="width: 256px; height: 256px; border-radius: 9999px; font-size: 88px; background: linear-gradient(135deg, #9E64FF, #602895); box-shadow: 0 0 0 14px rgba(158,100,255,.16);"
      >
        {{ initials }}
      </div>
      <div>
        <div class="font-extrabold text-white" style="font-size: 50px; line-height: 1.1;">{{ userName }}</div>
        <div v-if="title" style="font-size: 28px; font-weight: 500; color: #D2A1FF; margin-top: 8px;">{{ title }}</div>
      </div>
    </div>

    <!-- Panneau droit : score & détails -->
    <div class="flex flex-col justify-center" style="width: 62%; padding: 48px 64px; gap: 24px;">
      <div class="flex flex-col" style="gap: 12px;">
        <div style="font-size: 18px; letter-spacing: .16em; text-transform: uppercase; font-weight: 700; color: #9aa0aa;">
          BIG Score
        </div>
        <div class="flex items-baseline font-extrabold" style="gap: 8px;">
          <span
            class="bg-clip-text text-transparent"
            style="font-size: 100px; line-height: .9; background-image: linear-gradient(90deg, #D2A1FF, #9E64FF);"
          >{{ score }}</span>
          <span style="font-size: 36px; font-weight: 600; color: #7a808a;">/100</span>
        </div>
        <div style="height: 10px; border-radius: 9999px; background: #26262c; width: 78%; overflow: hidden;">
          <div :style="{ height: '100%', borderRadius: '9999px', width: barWidth, background: 'linear-gradient(90deg,#D2A1FF,#9E64FF)' }" />
        </div>
      </div>

      <div v-if="topSkills.length">
        <div style="font-size: 16px; text-transform: uppercase; letter-spacing: .09em; font-weight: 700; color: #9aa0aa; margin-bottom: 14px;">
          Top compétences
        </div>
        <div class="flex flex-wrap" style="gap: 12px;">
          <span
            v-for="skill in topSkills"
            :key="skill"
            style="font-size: 20px; padding: 8px 20px; border-radius: 9999px; background: #1f1f24; border: 1px solid #34343c; color: #e6e6ea;"
          >{{ skill }}</span>
        </div>
      </div>

      <div v-if="context && context.length">
        <div style="font-size: 16px; text-transform: uppercase; letter-spacing: .09em; font-weight: 700; color: #9aa0aa; margin-bottom: 14px;">
          {{ t('big_score.share_card_context') }}
        </div>
        <div class="flex flex-wrap" style="gap: 12px;">
          <span
            v-for="item in context"
            :key="item.label"
            class="inline-flex items-center"
            style="font-size: 20px; gap: 10px; padding: 8px 20px; border-radius: 9999px; background: #1f1f24; border: 1px solid #34343c; color: #e6e6ea;"
          >
            <svg
              viewBox="0 0 24 24"
              fill="none"
              stroke="#9E64FF"
              stroke-width="1.5"
              style="width: 22px; height: 22px; flex-shrink: 0;"
              v-html="contextIconSvg(item.icon)"
            />
            {{ item.label }}
          </span>
        </div>
      </div>
    </div>

    <!-- Logo BIG (pied gauche) -->
    <svg viewBox="0 0 974 480" xmlns="http://www.w3.org/2000/svg" style="position: absolute; left: 56px; top: 44px; height: 52px; opacity: .95;">
      <path d="M676.354 189.424V455.76H566.519V189.424H676.354Z" fill="white"/>
      <path d="M704.203 279.978C704.203 268.564 705.22 257.53 707.254 246.876C709.542 235.969 713.736 226.33 719.838 217.96C726.193 209.336 734.964 202.487 746.149 197.414C757.335 192.087 771.825 189.424 789.621 189.424H949.779V263.998H800.298C795.976 263.998 792.163 265.647 788.858 268.944C785.807 271.988 784.282 275.666 784.282 279.978V365.206C784.282 369.518 785.807 373.323 788.858 376.62C792.163 379.664 795.976 381.186 800.298 381.186H869.7V354.552H812.5V296.009H949.779V455.76H906.689H890.055C890.055 455.76 879.859 455.76 868.205 455.76C846.841 455.76 847.456 455.76 834.999 455.76H789.621C771.825 455.76 757.335 453.224 746.149 448.15C734.964 442.824 726.193 435.975 719.838 427.605C713.736 418.98 709.542 409.341 707.254 398.688C705.22 387.781 704.203 376.62 704.203 365.206V279.978Z" fill="white"/>
      <path d="M24 455.761H166.88L205.206 421.819V295.271L24 455.761Z" fill="#D8ADFF"/>
      <path d="M478.189 109.573C490.369 114.636 500.85 121.727 509.645 130.845C513.508 134.556 517.006 138.579 520.139 142.893L654.383 24H511.503L424.033 101.468H439.625C453.497 101.468 466.348 104.172 478.189 109.573Z" fill="#D8ADFF"/>
      <path d="M439.625 101.469C453.498 101.469 466.348 104.172 478.19 109.573C490.369 114.636 500.85 121.727 509.645 130.846C513.508 134.557 516.999 138.579 520.139 142.893C524.42 148.778 528.031 155.226 530.958 162.244C536.368 174.066 539.076 186.896 539.076 200.739C539.076 216.949 535.691 231.806 528.927 245.312V245.305C522.163 258.473 512.864 269.612 501.022 278.731C512.864 287.849 522.163 299.162 528.927 312.667C535.691 326.173 539.076 340.858 539.076 356.73C539.076 370.573 536.368 383.575 530.958 395.729C525.887 407.545 518.778 418.015 509.645 427.134C500.85 435.908 490.369 442.998 478.19 448.406C466.348 453.469 453.498 456 439.625 456H205.206V421.951L311.759 327.631V369.983H404.108C409.856 369.983 414.761 367.955 418.823 363.906C423.217 359.513 425.421 354.45 425.421 348.711C425.421 342.972 423.217 338.075 418.823 334.026C414.761 329.632 409.856 327.439 404.108 327.439H311.978L415.205 236.061C416.042 235.318 416.838 234.536 417.588 233.715C422.931 227.883 425.932 220.242 425.932 212.263V207.751C425.932 196.77 417.018 187.87 406.019 187.87H326.475V187.877H326.222L205.266 294.828C205.339 219.315 205.425 223.854 205.206 101.469H439.625Z" fill="white"/>
    </svg>
  </div>
</template>

<script setup lang="ts">
const props = defineProps<{
  score: number;
  topSkills: string[];
  context?: { icon: string; label: string }[];
  userName: string;
  title?: string | null;
  photoDataUrl?: string | null;
}>();

const { t } = useI18n();

// Inline SVG inner-content for the share card. We cannot use Nuxt's <Icon>
// here because the card is rasterized by html-to-image (mask/font icons are
// not captured); inline SVG always renders. Paths are from the Solar set.
function contextIconSvg(key: string): string {
  switch (key) {
    case "industry":
      return '<path stroke-linecap="round" d="M22 22H2"/><path d="M17 22V6c0-1.886 0-2.828-.586-3.414S14.886 2 13 2h-2c-1.886 0-2.828 0-3.414.586S7 4.114 7 6v16m14 0V8.5c0-1.404 0-2.107-.337-2.611a2 2 0 0 0-.552-.552C19.607 5 18.904 5 17.5 5M3 22V8.5c0-1.404 0-2.107.337-2.611a2 2 0 0 1 .552-.552C4.393 5 5.096 5 6.5 5"/><path stroke-linecap="round" d="M12 22v-3m-2-7h4m-8.5-1H7m-1.5 3H7m10-3h1.5M17 14h1.5m-13-6H7m10 0h1.5M10 15h4"/><circle cx="12" cy="7" r="2"/>';
    case "persona":
      return '<circle cx="12" cy="6" r="4"/><ellipse cx="12" cy="17" rx="7" ry="4"/>';
    case "market_segment":
      return '<path stroke-linecap="round" d="M22 22H2"/><path d="M17 22V6c0-1.886 0-2.828-.586-3.414S14.886 2 13 2h-2c-1.886 0-2.828 0-3.414.586S7 4.114 7 6v16m14 0V11.5c0-1.405 0-2.107-.337-2.611a2 2 0 0 0-.552-.552C19.607 8 18.904 8 17.5 8M3 22V11.5c0-1.405 0-2.107.337-2.611a2 2 0 0 1 .552-.552C4.393 8 5.096 8 6.5 8"/><path stroke-linecap="round" d="M12 22v-3M10 5h4m-4 3h4m-4 3h4m-4 3h4"/>';
    case "deal_size":
      return '<circle cx="12" cy="12" r="10"/><path stroke-linecap="round" d="M12 6v12m3-8.5C15 8.12 13.657 7 12 7S9 8.12 9 9.5s1.343 2.5 3 2.5s3 1.12 3 2.5s-1.343 2.5-3 2.5s-3-1.12-3-2.5"/>';
    default:
      return "";
  }
}

const barWidth = computed(() => `${Math.min(100, Math.max(0, props.score))}%`);

const initials = computed(() => {
  const parts = props.userName.trim().split(/\s+/);
  const first = parts[0]?.[0] ?? '';
  const last = parts.length > 1 ? parts[parts.length - 1][0] : '';
  return (first + last).toUpperCase();
});
</script>
